import "./RemoveModal.scss";

import React from "react";

import { Button, Modal, Typography } from "antd";
import PropTypes from "prop-types";

const RemoveModal = ({
  loading,
  handleOk,
  details,
  buttonName,
  cancelButtonName,
  handleCancel,
  loadCancelButton = false,
  actionButtonType = "",
  visible,
  setVisible,
  title,
}) => {
  return (
    <Modal
      visible={visible}
      title={title}
      onCancel={() => {
        setVisible(false);
      }}
      destroyOnClose
      footer={null}
      maskClosable
      centered
    >
      <>
        <div className="removePostModalBody">
          <Typography.Text className="text">{details}</Typography.Text>
        </div>

        <div className="removePostModalFooter">
          {cancelButtonName && handleCancel ? (
            <Button
              className="siteBtn grayBtn"
              style={{ marginRight: 12 }}
              disabled={loading}
              loading={loadCancelButton ? loading : false}
              onClick={handleCancel}
            >
              {cancelButtonName || "Cancel"}
            </Button>
          ) : null}

          <Button
            className={`siteBtn accentBtnV1 ${actionButtonType}`}
            disabled={loading}
            loading={loading}
            onClick={handleOk}
          >
            {buttonName || "Remove"}
          </Button>
        </div>
      </>
    </Modal>
  );
};

RemoveModal.propTypes = {
  loading: PropTypes.bool,
  handleOk: PropTypes.func,
  buttonName: PropTypes.string,
  cancelButtonName: PropTypes.string,
  handleCancel: PropTypes.func,
  loadCancelButton: PropTypes.bool,
  actionButtonType: PropTypes.string,
  details: PropTypes.string,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  title: PropTypes.string,
};

export default RemoveModal;
